<div class="header" [class.collapsed]="collapsed" [ngClass]="{ dropcontentavailable: !!eventsList.length }" (click)="toggleSelector()">
    <div class="header-title">
        @if (selectedEvent) {
            <vn-icon class="icon" size="16" [name]="'sports-' + selectedEvent!.sportId" />
            <div class="selected">{{ !!selectedEvent && selectedEvent!.name }}</div>
        }

        @if (!selectedEvent) {
            {{ selectorTitle }}
        }
    </div>
    @if (!!eventsList.length) {
        <ms-expansion-panel [collapsed]="collapsed" />
    }
</div>
@if (!collapsed && !!eventsList.length) {
    <div class="content" [ngClass]="containerHeight">
        <div class="list" msScrollToActive (scroll)="scrolled($event)">
            @for (item of eventsList; track $index) {
                <div class="group">
                    <vn-icon class="icon" size="12" [name]="'sports-' + item.id" />
                    <div class="title">{{ item.name }}</div>
                </div>
                @for (child of item.children; track $index) {
                    <div class="option" [class.active]="selectedEventId && child.id === selectedEventId" (click)="changed(child)">
                        <div>{{ child.name }}</div>
                    </div>
                }
            }
        </div>
    </div>
}
